// src/modules/competition/pages/CompetitionPage/index.js
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import CompetitionOverview from '../../components/CompetitionOverview';
import Loading from '../../../../shared/components/Loading';
import { useWarmupTimer } from '../../../../shared/hooks/useWarmupTimer';
import { useCompetitionData } from '../../hooks/useCompetitionData';

const CompetitionPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { competition, competitors, isLoading, error, reloadData } = useCompetitionData(id);
    const { isWarmup } = useWarmupTimer(isLoading);

    const handleUsernameClick = (username) => {
        navigate(`/profile/${username}`);
    };

    if (isLoading) return <Loading isWarmup={isWarmup} />;
    if (error) return <div>Error: {error}</div>;
    if (!competition) return <div>No competition found</div>;

    return (
        <CompetitionOverview
            competitors={competitors}
            lowestCompetitor={competitors[competitors.length - 1]}
            currentPeriod={{
                startDate: competition.startDate,
                endDate: competition.endDate
            }}
            onUsernameClick={handleUsernameClick}
            isUserJoined={competition.isUserJoined}
            competitionId={id}
            competitionName={competition.name}
            pointTarget={competition.pointTarget}
            ministerOfActivity={competition.ministerOfActivity}
            onJoinSuccess={reloadData}
            isTeamBased={competition.isTeamBased ?? false}
            teams={competition.teams || []}
            winnerCalculationMethod={competition.winnerCalculationMethod}
        />
    );
};

export default CompetitionPage;
